import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import GoBack from "common-components/GoBack";
import { media, isMobile  } from "utils/style";
import CommonContainer from "common-components/Container";
import StyledLink from "common-components/StyledLink";
import { ENDPOINTS } from "utils/endpoints";
import { fetchPageContent } from "../DownloadAndDelete/actions";
import FallbackUI from "../FallbackUI/FallbackUI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import FetchPageContent from "../../../hoc/FetchPageContent";
import {Button}  from "@vds/buttons";
import { TitleLockup } from "@vds/type-lockups";
class FormerCustomerCorrectionRequestInformation extends Component {
  componentDidMount() {
    let url = ENDPOINTS.FETCH_FORMER_CUSTOMER_CORRECTION_PAGE_NEW;
    this.props.fetchPageContent(url).then(() => {
      if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
        this.props.setA11yContent("submit correction request information", this.props.pageContent.sc_pagetitle);
      }
    });
  }

  render() {
    if (this.props.loading) {
      return <RectangleLoader />;
    }
    const { pageContent } = this.props;
    if (this.props.error) {
      return <FallbackUI />;
    } else if (!pageContent) {
      return <FallbackUI />;
    } else {
      return (
        <Fragment>
          <Container>
          <TitleLockup 
              viewport={isMobile ? "mobile": "desktop"}
              surface= 'light'
              textAlignment= 'left'
              data={{                
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: <H1>{pageContent.section_title}</H1>
                 },
                 subtitle:{
                    size: 'bodyLarge',                    
                    children: <Div>{convertStringToElements(pageContent.section_description)}</Div>              
                 }
               }}          
             />
            {/* <H1>{pageContent.section_title}</H1>
            <Div>{convertStringToElements(pageContent.section_description)}</Div> */}

            <Button
                style={{ marginTop: "48px" }}
                background={pageContent.buttons[0].type}
                onClick={() => this.props.history.push({
                  pathname:"verify-customer",
                  state: {
                    flow: "correction",
                    currentIntent: "correct",
                    serviceType: "former"
                  }
                })
                }
              >
               {pageContent.buttons[0].text}
              </Button> 

            {/* <StyledLink
              style={{ marginTop: "48px" }}
              background={pageContent.buttons[0].type}
              to={{ pathname: "verify-customer", state: { flow: "correction", currentIntent: "correct", serviceType: "former" } }}>
              {pageContent.buttons[0].text}
            </StyledLink> */}
          </Container>
        </Fragment>
      );
    }
  }
}

FormerCustomerCorrectionRequestInformation.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({ pageContent: { former_correct: pageContent }, loadingAndErrorState: { loading, error }, }) => ({
  pageContent,
  loading,
  error
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, fetchPageContent }
  ),
)(FormerCustomerCorrectionRequestInformation);

const Div = styled.div`
  max-width: 490px;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.5px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;

  p {
      padding: 10px 0;
      font-family: 'Verizon-NHG-eDS' !important;
      font-size: 16px !important;
      line-height: 20px !important;
    }
    p:first-of-type {
      padding: 0;
    }
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 597px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  padding-bottom: 16px;
  font-weight:300;

  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  `}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
    padding: 48px 16px ;
  `}
`;
